(($, window) => {
  Drupal.behaviors.animationTimeline = {
    attach(context) {
      const timelineAnimation = (
        windowHeight,
        windowScrollTop,
        parentEl,
        listEl,
      ) => {
        const windowBottomPosition = windowScrollTop + windowHeight;

        if (parentEl.length > 0) {
          listEl.each((i, el) => {
            const element = $(el);
            const elementHeight = element.outerHeight();
            const elementTopPosition = element.offset().top;
            const elementBottomPosition = elementTopPosition + elementHeight;

            if (
              elementBottomPosition >= windowScrollTop &&
              elementTopPosition <= windowBottomPosition
            ) {
              element.addClass('in-view');
            } else {
              element.removeClass('in-view');
            }
          });
        }
      };

      timelineAnimation(
        $(window).height(),
        $(window).scrollTop(),
        $('.content--timeline'),
        $('.content--timeline > ul > li'),
      );
      $(window, context).scroll(() => {
        timelineAnimation(
          $(window).height(),
          $(window).scrollTop(),
          $('.content--timeline'),
          $('.content--timeline > ul > li'),
        );
      });
    },
  };
})(jQuery, window);
